import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as DefaultBrandingIcon } from "../../assets/previewPage/defaultBrandingIcon.svg";
import {
  AvatarCard,
  LinksCard,
  SocialCard,
  QrImageCard,
  FaqCard,
  ImageCard,
  DividerCard,
  ImageGridCard,
  CountDownCard,
  YoutubeCard,
  InstagramCard,
  TwitterCard,
  TikTokCard,
  HeadingCard,
  HeaderTextCard,
} from "./cards";

// redux
import { gettingLinkPreview } from "../../redux/slices/linkPreview/linkPreviewSlice";
import { getScreenPreviewSetting } from "../../redux/slices/appearance/appearanceSlice";
import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet";
import useLocales from "../../hooks/useLocales";
import httpRequest from "../../axios/index";
import toast from "react-hot-toast";
import { setAllLangs } from "../../redux/slices/Languages/LanguagesSlice";

import LoadingScreen from "../../components/dashboard/LoadingScreen";
import LocationCard from "./cards/LocationCard";
import CookiesPreferenceConfirmModal from "../landingPages/CookiesPreferenceConfirmModal";
import { throttle } from "lodash";
import "../previewPage/dashboardMobilePreview/header.css";
import HeaderTextStickyCard from "./cards/HeaderTextStickyCard";

const PreviewPage = () => {
  const { allLangs = [] } = useSelector((state) => state?.language);

  const { user } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate, currentLang } = useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;
  const [backgroundStyles, setBackgroundStyles] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [brandingStyles, setBrandingStyles] = useState(null);
  const [seoStyles, setSeoStyles] = useState(null);
  const [favStyles, setFavStyles] = useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const headerTextCardRef = useRef(null); // Ref to track HeaderTextCard
  useEffect(() => {
    dispatch(getScreenPreviewSetting(user));
    dispatch(gettingLinkPreview(user));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  const [linkData, setLinkData] = useState(
    useSelector((state) => state?.linkPreview?.userLinkState?.response)
  );
  const filteredLinkData = linkData?.filter(
    (item) => item?.language === currentLang.value
  );

  const Linkdata = useSelector(
    (state) => state?.linkPreview?.userLinkState?.response
  );

  useEffect(() => {
    setLinkData(Linkdata);
  }, [Linkdata]);

  const userLinkLoading = useSelector(
    (state) => state?.linkPreview?.userLinkLoading
  );
  const gettingAppearanceLoading = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearanceLoading
  );
  const [linkStyls, setLinkStyles] = useState(
    useSelector(
      (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
    )
  );
  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );
  useEffect(() => {
    setLinkStyles(LinkStyls);
  }, [LinkStyls]);
  useEffect(() => {
    linkStyls?.map((item) => {
      if (item?.coloum_name === "background") {
        setBackgroundStyles(JSON.parse(item?.coloum_value));
      }
      if (item?.coloum_name === "branding") {
        setBrandingStyles(JSON.parse(item?.coloum_value));
      }
      if (item?.coloum_name === "seo") {
        setSeoStyles({ ...item, coloum_value: JSON.parse(item?.coloum_value) });
      }
      if (item?.coloum_name === "favIcon") {
        setFavStyles(JSON.parse(item?.coloum_value));
      }
      return null;
    });
  }, [linkStyls]);
  const { userLinkError, userLinkState, userLinkSuccess } = useSelector(
    (state) => state?.linkPreview
  );
  useEffect(() => {
    if (userLinkSuccess && userLinkState?.status === "failed") {
      if (userLinkState?.message === "Link not found") {
        navigate("/404");
      }
    } else if (userLinkError) {
      navigate("/500");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLinkLoading]);

  useEffect(() => {
    if (favStyles?.favFile) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        link.href = baseUrl + "/profile/" + favStyles?.favFile;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = baseUrl + "/profile/" + favStyles?.favFile;
      link.setAttribute("href", baseUrl + "/profile/" + favStyles?.favFile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favStyles]);

  useEffect(() => {
    if (seoStyles?.coloum_value?.meta_description) {
      let meta = document.querySelector("meta[name~='description']");
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        meta.content = seoStyles?.coloum_value?.meta_description;
        document.getElementsByTagName("head")[0].appendChild(meta);
      }
      meta.content = seoStyles?.coloum_value?.meta_description;
      meta.setAttribute("content", seoStyles?.coloum_value?.meta_description);
    }
  }, [seoStyles]);

  const userId = useSelector(
    (state) => state?.linkPreview?.userLinkState?.result?.user
  );

  const bgImageStyle =
    backgroundStyles?.backgroundType === "abstractGradients"
      ? {
          backgroundImage: `url('${backgroundStyles?.backgroundOptionVal}')`,
        }
      : backgroundStyles?.backgroundType === "customColor"
      ? {
          background: backgroundStyles?.backgroundOptionVal,
        }
      : backgroundStyles?.backgroundType === "customImage"
      ? {
          backgroundImage: `url('${baseUrl}/profile/${backgroundStyles?.backgroundOptionVal}')`,
        }
      : {};

  const fonts =
    linkStyls?.filter((item) => item.coloum_name === "fonts")?.[0] || null;
  const fontValue = fonts?.coloum_value && JSON.parse(fonts?.coloum_value);

  const [fontStyle, setFontStyle] = useState(null);
  useEffect(() => {
    if (fontValue) {
      setFontStyle({ ...fontStyle, fontFamily: fontValue?.fontType?.value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fonts]);

  const linkId = useSelector(
    (state) => state?.linkPreview?.userLinkState?.result?._id
  );

  const handleSocialMediaClick = async (platform) => {
    try {
      let columnType = "";
      switch (platform) {
        case "Instagram":
          columnType = "Instagram";
          break;
        case "Facebook":
          columnType = "Facebook";
          break;
        case "Twitter":
          columnType = "Twitter";
          break;
        case "LinkedIn":
          columnType = "LinkedIn";
          break;
        case "Pinterest":
          columnType = "Pinterest";
          break;
        case "YouTube":
          columnType = "YouTube";
          break;
        default:
          columnType = "";
          break;
      }
      if (!columnType || columnType.trim() === "") {
        return;
      }

      const payload = {
        userId: userId,
        linkId: linkId,
        columnType: columnType,
      };
      const url = "/api/user/saveanalytics";

      const response = await httpRequest.post(url, payload);

      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        toast.success(result);
      }
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const languagesShow = async () => {
    if (!userId) {
      if (allLangs.length === 0) {
        dispatch(setAllLangs({ addedLanguages: [] }));
      }
      return null;
    }
    try {
      const url = `/api/user/languages/${userId}`;
      const response = await httpRequest.get(url);
      const resultLanguage = response?.data?.data || [];
      const status = response?.data?.status;

      if (status === "success") {
        dispatch(setAllLangs({ addedLanguages: resultLanguage }));
      }
    } catch (error) {
      // if (error?.response?.data?.status === "failed") {
      //   toast.error(error?.response?.data?.message);
      // } else {
      //   toast.error("Something went wrong");
      // }
      console.log(error);
    }
  };

  useEffect(() => {
    if (userId) {
      languagesShow();
    }
  }, [userId]);

  const handleCookiePreferencesClick = () => {
    setIsModalOpen(true);
  };

  const handleScroll = useCallback(
    throttle(() => {
      const scrollableContainer = document.getElementById("scroll-container");
      if (scrollableContainer && headerTextCardRef.current) {
        const scrollTop = scrollableContainer.scrollTop;
        const headerTextCardBottom =
          headerTextCardRef.current.getBoundingClientRect().bottom;

        // Check if HeaderTextCard has been fully scrolled past
        const isFullyScrolledPast = scrollTop > headerTextCardBottom;
        setIsSticky(isFullyScrolledPast);
      }
    }, 100),
    []
  );

  useEffect(() => {
    const scrollableContainer = document.getElementById("scroll-container");
    if (scrollableContainer) {
      scrollableContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollableContainer) {
        scrollableContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    if (gettingAppearanceLoading || userLinkLoading) {
      const scrollableContainer = document.getElementById("scroll-container");
      if (scrollableContainer) {
        scrollableContainer.scrollTop = 0;
      }
      setIsSticky(false);
    }
  }, [gettingAppearanceLoading, userLinkLoading]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />

        {favStyles?.favFile && (
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href={baseUrl + "/profile/" + favStyles?.favFile}
          ></link>
        )}
        <title>
          {seoStyles?.coloum_value?.pageTitle || "Bill.Bio | Profile Page"}
        </title>
        <meta
          name="description"
          content={seoStyles?.coloum_value?.meta_description}
        />

        <meta
          property="og:title"
          content={
            seoStyles?.coloum_value?.pageTitle || "Bill.Bio | Profile Page"
          }
        />
        <meta
          property="og:description"
          content={seoStyles?.coloum_value?.meta_description}
        />
        {seoStyles?.coloum_value?.seo_picture && (
          <meta
            property="og:image"
            content={
              baseUrl + "/profile/" + seoStyles?.coloum_value?.seo_picture
            }
          />
        )}
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
      </Helmet>

      {(gettingAppearanceLoading || userLinkLoading) && <LoadingScreen />}

      {(!gettingAppearanceLoading || !userLinkLoading) && (
        <>
          <div
            style={bgImageStyle}
            className={`flex justify-center ${
              backgroundStyles?.backgroundType === "simpleGradients"
                ? backgroundStyles?.backgroundOptionVal
                : backgroundStyles?.backgroundType === "abstractGradients"
                ? "bg-cover bg-center bg-no-repeat"
                : backgroundStyles?.backgroundType === "customImage"
                ? "bg-cover bg-center bg-no-repeat"
                : ""
            } ${
              !backgroundStyles
                ? "bg-gradient-to-b from-[#9BF5BB] to-[#4F8BC1]"
                : ""
            } max-h-screen min-h-screen h-screen overflow-y-auto overflow-x-clip no-scrollbar`}
            id="scroll-container"
            onScroll={handleScroll}
          >
            <div
              className={`w-full flex flex-col min-h-[clac(100vh_-_180px)] justify-between items-center`}
            >
              {isSticky && (
                <div
                  className={`flex flex-col items-center w-full  ${
                    isSticky ? "sticceky" : ""
                  }`}
                >
                  {filteredLinkData?.map((item, i) => {
                    if (item.coloum_name === "headertext" && item.status) {
                      return (
                        <HeaderTextStickyCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                          isSticky={isSticky}
                        />
                      );
                    }
                    return null;
                  })}
                </div>
              )}

              <div
                className="flex flex-col items-center w-full"
                ref={headerTextCardRef}
              >
                {filteredLinkData?.map((item, i) => {
                  if (item.coloum_name === "headertext" && item.status) {
                    return (
                      <HeaderTextCard
                        key={item?._id}
                        item={item}
                        styles={linkStyls}
                      />
                    );
                  }
                  return null;
                })}
              </div>

              <div className="flex flex-col gap-[20px] md:gap-[30px] items-center pt-[20px] px-[30px] md:max-w-[690px] w-full">
                {filteredLinkData?.map((item, i) => {
                  switch (item.coloum_name) {
                    case "link":
                      return item?.status ? (
                        <LinksCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                          handleSocialMediaClick={handleSocialMediaClick}
                        />
                      ) : null;
                    case "avatar":
                      return item?.status ? (
                        <AvatarCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "share":
                      return item?.status ? (
                        <QrImageCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "faq":
                      return item?.status ? (
                        <FaqCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "youtube":
                      return item?.status ? (
                        <YoutubeCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "tiktok":
                      return item?.status ? (
                        <TikTokCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "instagram":
                      return item?.status ? (
                        <InstagramCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "twitter":
                      return item?.status ? (
                        <TwitterCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "image":
                      return item?.status ? (
                        <ImageCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "imageGrid":
                      return item?.status ? (
                        <ImageGridCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "divider":
                      return item?.status ? (
                        <DividerCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "countdown":
                      return item?.status ? (
                        <CountDownCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "heading":
                      return item?.status ? (
                        <HeadingCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "social":
                      return item?.status ? (
                        <SocialCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    case "mapData":
                      return item?.status ? (
                        <LocationCard
                          key={item?._id}
                          item={item}
                          styles={linkStyls}
                        />
                      ) : null;
                    default:
                      return null;
                  }
                })}
              </div>
              <div className="pb-[30px] lg:pb-[50px] px-[20px] pt-[82.16px] md:pt-[78.27px] max-w-[301px] md:max-w-[690px] w-full">
                <div className="flex justify-center">
                  {brandingStyles ? (
                    brandingStyles?.brandingStatus ? (
                      brandingStyles?.brandingTitle ? (
                        <a
                          href={brandingStyles?.brandingUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p
                            style={fontStyle}
                            className="text-body_copy2_black text-center"
                          >
                            {brandingStyles?.brandingTitle}
                          </p>
                        </a>
                      ) : (
                        <a
                          href={"/bill"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <DefaultBrandingIcon className="w-[80.3px] md:w-auto" />
                        </a>
                      )
                    ) : brandingStyles?.paidUser ? null : (
                      <a
                        href={"/bill"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <DefaultBrandingIcon className="w-[80.3px] md:w-auto" />
                      </a>
                    )
                  ) : (
                    <a
                      href={"/bill"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex justify-center items-center"
                    >
                      <DefaultBrandingIcon className="w-[80.3px] md:w-auto" />
                    </a>
                  )}
                </div>
                <div className="mt-[16px] sm:mt-[20px] flex justify-center items-center text-dark_bg_v1">
                  <a
                    href={"/bill/report-abuse"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="text-small3 sm:text-small2_b">
                      {translate("header.ReportAbuse")}&nbsp;·
                    </p>
                  </a>
                  <div
                    className="cursor-pointer text-small3 sm:text-small2_b"
                    onClick={handleCookiePreferencesClick}
                  >
                    &nbsp;
                    {translate("footer.Update_cookies_preferences")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <CookiesPreferenceConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default PreviewPage;
